import Component from '../inherited/Component'

export default class LoginWithSoho extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  openPopupCenter ({url, title, w, h}) {
    const y = window.top.outerHeight / 2 + window.top.screenY - ( h / 2);
    const x = window.top.outerWidth / 2 + window.top.screenX - ( w / 2);
    return window.open(url, title, `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
  }

  mount () {
    this._elem.addEventListener('click', e => {
      e.preventDefault()

      const popup = this.openPopupCenter({
        url: this._elem.getAttribute('href'),
        title: "Login",
        w: 700,
        h: 700
      });
      const checkPopup = setInterval(() => {
       if (popup.closed) clearInterval(checkPopup)
        try {
          if (popup.window.location.href
           .includes(window.location.host)) {
            console.log(popup.window.location.href)
            window.location.href = popup.window.location.href
            popup.close()
          }
        } catch (e) {
          
        }
        if (!popup || !popup.closed) return;
        clearInterval(checkPopup);
      }, 100);

    })
  }
}